import { vModelText as _vModelText, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2998abc0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "form-group" }
const _hoisted_2 = ["placeholder"]
const _hoisted_3 = ["title"]
const _hoisted_4 = {
  key: 0,
  class: "spinner-border text-secondary mx-auto"
}
const _hoisted_5 = {
  key: 0,
  class: "mt-1 mb-0 w-100"
}
const _hoisted_6 = ["innerHTML"]
const _hoisted_7 = {
  key: 2,
  class: "invalid-feedback text-danger fw-bold mb-0"
}
const _hoisted_8 = {
  key: 1,
  class: "file-url-container"
}
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "fileName",
  class: "fw-medium ms-1"
}, "Archivo actual:", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.viewMode != _ctx.viewModes.visualization)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: _normalizeClass(["input-group has-validation mb-2", { 'no-click': _ctx.attributes.disabled }])
        }, [
          _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.fileName) = $event)),
            type: "text",
            "aria-label": "Seleccione un archivo",
            class: _normalizeClass(["form-control", { 'is-invalid': _ctx.v$.current_file.$error || _ctx.error }]),
            placeholder: 
          !_ctx.fileName && !_ctx.firstLoad
            ? 'Haga click aquí para cambiar el archivo seleccionado'
            : 'Haga clic aquí para seleccionar el archivo a subir'
        ,
            onKeydown: _cache[1] || (_cache[1] = (event) => event.preventDefault()),
            onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.showFileSelectDialog && _ctx.showFileSelectDialog(...args)))
          }, null, 42, _hoisted_2), [
            [_vModelText, _ctx.fileName]
          ]),
          _createElementVNode("span", {
            class: "input-group-text cursor-pointer show-dialog-button",
            "data-bs-toggle": "tooltip",
            "data-bs-placement": "right",
            title: _ctx.icon === 'fa-xmark' ? 'Remover' : 'Cargar',
            onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.showFileSelectDialog && _ctx.showFileSelectDialog(...args)))
          }, [
            (_ctx.isWaiting)
              ? (_openBlock(), _createElementBlock("span", _hoisted_4))
              : (_openBlock(), _createBlock(_component_font_awesome_icon, {
                  key: 1,
                  icon: _ctx.icon,
                  size: "lg",
                  class: "mx-auto"
                }, null, 8, ["icon"]))
          ], 8, _hoisted_3),
          _createElementVNode("input", {
            ref: "uploadInput",
            type: "file",
            class: "d-none",
            onChange: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.getFile && _ctx.getFile(...args)))
          }, null, 544),
          (_ctx.v$.current_file.$errors.length)
            ? (_openBlock(), _createElementBlock("ul", _hoisted_5, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.v$.current_file.$errors, (error) => {
                  return (_openBlock(), _createElementBlock("li", {
                    key: error.$uid,
                    class: "text-danger fw-bold mb-0"
                  }, _toDisplayString(error.$message), 1))
                }), 128))
              ]))
            : _createCommentVNode("", true),
          (_ctx.serverErrors.length)
            ? (_openBlock(), _createElementBlock("ul", {
                key: 1,
                class: _normalizeClass(["mb-0", { 'mt-1': !_ctx.v$.current_file.$errors.length }])
              }, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.serverErrors, (error, index) => {
                  return (_openBlock(), _createElementBlock("li", {
                    key: `${_ctx.attributes.name}-error-${index}`,
                    class: "text-danger fw-bold mb-0"
                  }, [
                    _createElementVNode("div", { innerHTML: error }, null, 8, _hoisted_6)
                  ]))
                }), 128))
              ], 2))
            : _createCommentVNode("", true),
          (_ctx.error)
            ? (_openBlock(), _createElementBlock("span", _hoisted_7, _toDisplayString(_ctx.error), 1))
            : _createCommentVNode("", true)
        ], 2))
      : _createCommentVNode("", true),
    (_ctx.current_file.document_id)
      ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
          _hoisted_9,
          _createElementVNode("span", {
            class: "link-primary link-offset-2 cursor-pointer ms-2",
            onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.getDocument()))
          }, _toDisplayString(_ctx.current_file.name || _ctx.current_file.document_id), 1)
        ]))
      : _createCommentVNode("", true)
  ]))
}